import { Layers } from "lucide-react";
import { canAccess, roleAccess, type AccessVerb } from "@hisense/shared";
import { useAuth } from "@/app/auth";
import { SettledRules } from "@/components/ui/SettledRules";

/**
 * Quy tắc của Định mức vật tư — chốt 20/09/2026 theo chuẩn (lượng chuẩn và đơn vị, phụ trội cộng vào vật tư, một bản đang áp dụng và
 * cố định BOM con, không làm bản riêng theo khách, ai được làm gì), khách bác lại được. Trước đây là ba thẻ vàng rải trong trang sửa.
 *
 * Phần thật sự phải hỏi khách — BOM thật của Hisense, tỷ lệ phụ trội được duyệt — là DỮ LIỆU của khách, không bịa ra được; nó nằm ở
 * mục 26 bộ câu hỏi và không chặn việc dùng màn hình.
 */
export const BOM_RULES_SETTLED = ["basis", "allowance", "revision", "scope", "authority"] as const;

export function BomRules() {
  return <SettledRules ns="boms" rules={BOM_RULES_SETTLED} icon={Layers} />;
}

/** Cùng bộ giải quyền với máy chủ (ô tick menu Định mức vật tư) — trước 20/09/2026 trang này chặn cứng theo vai trò admin. */
export function useBomAccess() {
  const { user } = useAuth();
  const access = user ? user.access ?? roleAccess(user.role) : null;
  return (verb: AccessVerb) => !!access && canAccess(access, "boms", verb);
}
